import { AutoMap } from "@automapper/classes";
import { BaseModel } from "../base/base.model";
import { createMap, forMember, mapFrom, } from '@automapper/core';
import { mapper } from "src/app/infrastructure/infrastructure-services/common/mapper";

export interface IExchangeRateModel extends BaseModel {
  rateDate: string;
  currency: string;
  rate: number;
  currentMonth: number;
  currentYear: number;
  code: number;
  selectedDate : number;

}
// export interface IExchangeRateModel {
//   rateDate: string;
//   currency: string;
//   rate: number;
//   currentMonth: number;
//   currentYear: number;
//   code: number;

// }

export class ExchangeRateModel implements IExchangeRateModel {
  @AutoMap() rateDate: string = "";
  @AutoMap() currency: string = "";
  @AutoMap() rate: number = 0;
  //@AutoMap() lstMonths: MonthModel[] = [];
  @AutoMap() currentMonth: number = 0;
  @AutoMap() currentYear: number = 0;
  @AutoMap() code!: number;
  @AutoMap() selectedDate: number=1;
}

export class MonthModel {
  id: number = 0;
  name: string = "";
}

export interface IExchangeRateModelSAP {
  RateDate: string;
  Currency: string;
  Rate: number;
 }

export class ExchangeRateModelSAP implements IExchangeRateModelSAP {
  @AutoMap() RateDate: string = "";
  @AutoMap() Currency: string = "";
  @AutoMap() Rate!: number;
  constructor() {
    createMap(mapper, ExchangeRateModel, ExchangeRateModelSAP,
      forMember(
        (destination) => destination.Currency,
        mapFrom((source) => source.currency)
      ),
      forMember(
        (destination) => destination.Rate,
        mapFrom((source) => source.rate)
      ),
      forMember(
        (destination) => destination.RateDate,
        mapFrom((source) => source.rateDate)
      )
    );
  }


}

